import find from "lodash/find";
import get from "lodash/get";

import { evalVersion } from "./version";
import generateGraph from "./graph";

import { createResponse, getPayload } from "./api";

const execAnonymousFlow = async (
  survey,
  metadata,
  locale,
  branchName
) => {
  // const authStatus = false;
  const context = { ...metadata, locale, authenticated: false, };
  const version = evalVersion(survey, branchName, { metadata: context });

  if (version === undefined) {
    throw new Error("The specified version does not exist");
  }

  const versionObj = find(get(survey, 'versions', []), { name: version.name });

  // Create graph from blocks sequence
  const graph = generateGraph(survey, versionObj);

  const surveyId = get(survey, "_id");
  const userId = undefined;
  const jwtToken = undefined;

  const response = await createResponse(
    surveyId,
    userId,
    locale,
    { graph, version: version.name },
    metadata,
    jwtToken
  );
  const responseId = get(response, "id", null);
  const payload = await getPayload(surveyId, userId, responseId, jwtToken);

  return { responseId, payload, version };
};

export default execAnonymousFlow;
